/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React from "react";
import tw, { css, theme } from "twin.macro";
import { useMediaQuery } from "~hooks";

import Grid from "~components/styles/Grid.jsx";
import * as T from "~components/styles/Typography.jsx";

const headerSection = ({ data, colorChange }) => {
  const { backgroundColor, textColor, subheader, header } = data;

  const { isDesktop } = useMediaQuery();

  // useEffect(() => {
  //   if (colorChange && !isDesktop) {
  //     setBackgroundColor(theme`colors`?.[font]);
  //     setFontColor(theme`colors`?.[background]);
  //   } else {
  //     setBackgroundColor(theme`colors`?.[background]);
  //     setFontColor(theme`colors`?.[font]);
  //   }
  // }, [isDesktop, colorChange]);

  //

  return (
    <section
      css={[
        css`
          background-color: ${colorChange && !isDesktop
            ? textColor?.hex || `black`
            : backgroundColor?.hex || `white`};
          color: ${colorChange && !isDesktop
            ? backgroundColor?.hex || `white`
            : textColor?.hex || `black`};
        `,
        tw`relative block`
      ]}
    >
      <Grid node="article" _css={[tw`relative pt-12 md:pt-16 pb-12 md:pb-16`]}>
        <T.Head
          _css={[
            tw`col-start-1 md:col-start-4 col-span-24 md:col-span-18 relative text-center`
          ]}
          font="2"
        >
          {header}
        </T.Head>

        {subheader && (
          <T.Body
            _css={[
              tw`col-span-6 col-start-2 md:col-span-full relative mt-4 text-center`
            ]}
            font="h4"
          >
            {subheader}
          </T.Body>
        )}
      </Grid>
    </section>
  );
};

export default headerSection;
